export default "__VITE_ASSET__3qzi_Bxl__"